import React, {
    useState,
    useContext,
    useCallback, useRef,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    useModal,
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from 'gw-portals-viewmodel-react';
import { CSVLink } from 'react-csv';
import { messages as commonMessages } from 'gw-platform-translations';
import ServiceRequestService from 'gw-capability-servicerequest/services/ServiceRequestService';
import DateUtil from 'gw-portals-util-js/DateUtil';
import metadata from './ServiceReportPopup_AX.metadata.json5';
import messages from './ServiceReportPopup_AX.messages';

function ServiceReportPopup(props) {
    const {
        isOpen,
        onReject,
        allItems,
        authHeader
    } = props;
    const { showAlert } = useModal();

    const [serviceReportDTO, setServiceReportDTO] = useState({
        startDate: DateUtil.trimToMidnight(new Date()),
        endDate: new Date()
    });
    const [reportItems, setReportData] = useState([]);
    const { refreshData } = useDataRefresh();

    const translator = useContext(TranslatorContext);

    const headers = [
        { label: 'FECHA DE SERVICIO', key: 'createDate' },
        { label: 'NO. DE SERVICIO', key: 'serviceRequestNumber' },
        { label: 'ID', key: 'claimID' },
        { label: 'SIGUIENTE PASO', key: 'nextStep' },
        { label: 'ACCIÓN', key: 'defaultOperation' },
        { label: 'TIPO', key: 'requestKind' },
        { label: 'SERVICIOS', key: 'services' },
        { label: 'CLIENTE', key: 'customerContact' },
        { label: 'MONTO DEL SERVICIO', key: 'amountService' },
        { label: 'MONTO FACTURADO', key: 'amountServiceInvoice' },
        { label: 'ESTADO', key: 'lastInvoiceStatus' },
        { label: 'NO. DE REFERENCIA', key: 'referenceInvoiceNumber' },
        { label: 'NO. DE SOLICITUD', key: 'referenceInvoice' }
    ];

    const csvRef = useRef();

    const writeValue = useCallback(
        (value, path) => {
            const nDate = new Date(value.year, value.month, value.day);
            _.set(serviceReportDTO, path, nDate);
            setServiceReportDTO(serviceReportDTO);
            refreshData();
            setReportData(allItems.filter((item) => {
                const dateToValue = Date.parse(item.createDate);
                return (dateToValue >= serviceReportDTO.startDate
                    && dateToValue <= serviceReportDTO.endDate);
            }));
        },
        [reportItems, serviceReportDTO, refreshData]
    );

    const handleClose = useCallback(async () => {
        onReject();
    }, []);

    const handlePrint = useCallback(async () => {
        ServiceRequestService.getSystemParameterStringByNameAX('AX_Max_Number_Row_Report', authHeader).then(
            (maxRows) => {
                const rows = parseInt(maxRows);
                if (reportItems.length > 0 && reportItems.length <= rows) {
                    csvRef.current.link.click();
                } else if (reportItems.length > rows) {
                    showAlert({
                        title: translator(messages.maxElementsAlertTitle),
                        message: translator(messages.maxElementsAlertMessage),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                } else {
                    showAlert({
                        title: translator(messages.noRecordsFoundAlertTitle),
                        message: translator(messages.noRecordsFoundAlertMessage),
                        status: 'warning',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            }
        ).catch((e) => {
            showAlert({
                title: translator(messages.errorCCCommunicationAlertTitle),
                message: e.baseError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        });
    }, [reportItems]);

    const overrides = {
    };

    const resolvers = {
        resolveCallbackMap: {
            valueChangeFn: writeValue
        }
    };

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={translator(messages.modalTitle)} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent.content}
                    model={serviceReportDTO}
                    callbackMap={resolvers.resolveCallbackMap}
                    overrideProps={overrides}
                />
            </ModalBody>
            <ModalFooter>
                <Button type="text" onClick={handleClose}>
                    {translator(messages.cancelButton)}
                </Button>
                <Button onClick={handlePrint}>
                    {translator(messages.generateReportButton)}
                </Button>
                <CSVLink
                    data={reportItems}
                    filename="reporte.csv"
                    headers={headers}
                    ref={csvRef}
                />
            </ModalFooter>
        </ModalNext>
    );
}

ServiceReportPopup.propTypes = {
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func,
    onPrintReport: PropTypes.func,
    allItems: PropTypes.array,
    authHeader: PropTypes.object,
};

export default ServiceReportPopup;
